import { Notification } from "@/utils/notificationUtils";
import { useMutation } from "@tanstack/react-query";
import { t } from "i18next";
import { predictedCommissionsApi } from "../../../../modules/commissions/predicted/api";
import { RecalculatePredictedCommissions } from "../../../../modules/commissions/predicted/types";
import { PREDICTED_COMMISSIONS_QUERY_KEYS } from "./queryKeys";

export const useRecalculatePredictedCommissions = () => {
  return useMutation({
    mutationKey: PREDICTED_COMMISSIONS_QUERY_KEYS.recalculatePredictedCommissions(),
    meta: { globalSpinner: false },
    mutationFn: async (payload: RecalculatePredictedCommissions) => {
      const { data } = await predictedCommissionsApi.recalculatePredictedCommissions(payload);

      return data;
    },
    onSuccess: (responseData) => {
      Notification.getNotification().success({
        title: t("common.operationSuccess"),
        description: t("contract.helpers.successfulPredictedCommissionsRecalculation", { count: responseData }),
      });
    },
  });
};
